import { render, staticRenderFns } from "./bingli-list.vue?vue&type=template&id=891fa51e&scoped=true&"
import script from "./bingli-list.vue?vue&type=script&lang=ts&"
export * from "./bingli-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891fa51e",
  null
  
)

export default component.exports